import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as STATES from '../../../core/states/player.states';
// import { logDebugging } from '../../../log/logger';

export default function DurationLabel({ videoPlayer }) {
  const [duration, setDuration] = useState(videoPlayer.duration);
  const [currentTime, setCurrentTime] = useState(videoPlayer.currentTime);
  // logDebugging('DurationLabel Inicializo');

  useEffect(() => {
    const timerDuration = setInterval(() => {
      // logDebugging(`DurationLabel intervalo ${videoPlayer.currentTime}`);
      // 👇 Pass callback
      if (videoPlayer.state === STATES.STOPPED) {
        // eslint-disable-next-line no-undef
        window.clearInterval(timerDuration);
      }
      setDuration(videoPlayer.duration || 0);
      setCurrentTime(videoPlayer.currentTime || 0);
    }, 1000);
    return () => {
      // logDebugging(`ELIMINO`);
      // eslint-disable-next-line no-undef
      window.clearInterval(timerDuration);
    };
  });

  function fancyTimeFormat(seconds) {
    // Hours, minutes and seconds
    const h = Math.floor(seconds / 3600)
      .toString()
      .padStart(2, '0');
    const m = Math.floor((seconds % 3600) / 60)
      .toString()
      .padStart(2, '0');
    const s = Math.floor(seconds % 60)
      .toString()
      .padStart(2, '0');

    const dateFormated = `${h}:${m}:${s}`;

    return dateFormated.replace(/^00:/, '');
  }
  return (
    <div className="tpx-duration-label disable-select">
      <div>
        <span>{fancyTimeFormat(currentTime)}</span> / <span>{fancyTimeFormat(duration)}</span>
      </div>
    </div>
  );
}

DurationLabel.propTypes = {
  videoPlayer: PropTypes.object.isRequired,
};
